export default __webpack_public_path__ + "static/media/543.232023c9.png";